
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-apps/optimal-formulation-design",
      function () {
        return require("private-next-pages/data-apps/optimal-formulation-design/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-apps/optimal-formulation-design"])
      });
    }
  